<template>
  <div
    v-show="visible"
    class="element"
    :style="[wrapperStyle, rotationStyles, outlineStyle]"
  >
    <div
      class="resizer"
      :style="outlineStyle"
    >
      <div
        v-show="!hideHandles && showRotate"
        class="resize-btn resize rotate"
        :style="handleStyle"
      />
      <div
        v-show="!hideHandles"
        class="resize-btn resize top left top-left"
        :style="handleStyle"
      />
      <div
        v-show="!hideHandles"
        class="resize-btn resize top right top-right"
        :style="handleStyle"
      />
      <div
        v-show="!hideHandles"
        class="resize-btn resize bottom left bottom-left"
        :style="handleStyle"
      />
      <div
        v-show="!hideHandles"
        class="resize-btn resize bottom right bottom-right"
        :style="handleStyle"
      />
      <div
        v-show="!hideHandles"
        class="resize-btn resize top horizontal-center top-center"
        :style="handleStyle"
      />
      <div
        v-show="!hideHandles"
        class="resize-btn resize bottom horizontal-center bottom-center"
        :style="handleStyle"
      />
      <div
        v-show="!hideHandles"
        class="resize-btn resize left vertical-center left-center"
        :style="handleStyle"
      />
      <div
        v-show="!hideHandles"
        class="resize-btn resize right vertical-center right-center"
        :style="handleStyle"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    element: {
      type: Object,
      default: () => ({}),
    },
    scale: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapGetters('graphicsTemplate', [
      'getAllParents',
      'getElementById',
      'getAbsolutePosition',
      'getTransformStyles',
    ]),
    parents() {
      return this.element ? this.getAllParents(this.element.id) : [];
    },
    // Don't show resizer for data elements
    visible() {
      if (!this.element) {
        return false;
      }
      return ![
        'sheet-data',
        'social-data',
        'sportradar',
        'linked-data',
      ].includes(this.element.type);
    },

    hideHandles() {
      if (!this.element) {
        return false;
      }

      if (this.element.type === 'text') {
        // Disable resizing if text element is set to auto-resize
        return (
          this.element.styles.textBoxOption === 2
          && this.element.styles.textFlowOption === 1
        );
      }

      // Groups aren't manually resizable
      return [
        'group',
        'data-list',
        'social-data',
        'sportradar',
        'linked-data',
        'shoppable',
      ].includes(this.element.type);
    },

    // matches showTransformOptions in SidebarRight.vue
    showRotate() {
      if (!this.element) {
        return false;
      }

      return [
        'rectangle',
        'triangle',
        'image',
        'text',
        'date',
        'timer',
      ].includes(this.element.type);
    },

    handleStyle() {
      return {
        scale: 1 / this.scale,
      };
    },

    outlineStyle() {
      return {
        outline: `${0.15 / this.scale}em solid #2bacca`,
      };
    },

    wrapperStyle() {
      if (!this.element) {
        return {};
      }

      const {
        height, width,
      } = this.element.styles || {};

      const { top, left } = this.getAbsolutePosition(this.element.id, this.parents);

      return {
        position: 'absolute',
        top: `${top}px`,
        left: `${left}px`,
        height: `${height}px`,
        width: `${width}px`,
        pointerEvents: 'none',
      };
    },

    rotationStyles() {
      if (!this.element) {
        return {};
      }

      return {
        transform: `rotate(${this.element.rotate ?? 0}deg)`,
      };
    },
  },
};
</script>
